export default process.env.REACT_APP_UI_LIBRARY || 'material-ui'
